import { useState, useRef } from 'react';
import { original, rose, vaporwave, matrix } from 'react95/dist/themes';
import { BrowserRouter, Router, Routes, Route, Link, useNavigate} from "react-router-dom";
import { createGlobalStyle, ThemeProvider, createTheme} from 'styled-components';
import {
    AppBar,
  Button,
  MenuList,
  MenuListItem,
  ScrollView,
  Separator,
  Toolbar,
    Frame,
  Window,
    Handle,
    
  WindowContent,
  WindowHeader,
    TextInput,
    styleReset
} from 'react95';

const AboutPage = () => {
    const imgBox = useRef(null);
    const descBox = useRef(null);
    
    
    const Entries = [
        {
            name: "In defense of being a braindead doll",
            thought: "Yeah Idk, I mean I think now that I'm like finally achieving a modicum of hotness I'm starting to like kinda realize that like the overall vibe an aesthetic I fit best into is kinda that of the skinny, bougie, 'braindead' brandy wearing, match drinking LA girl. And honestly like idk if it's such a bad thing. I used to hold a kinda half resentment towards this type of girl but like idk. I think lwk I kinda just wanted to be her. And now that I am... I mean maybe I'm trying to intellectualize why I like being hot and getting (Especially male)attention but I don't think there's necessarily a vapidity or an absence of though in this archetype. I think it's moreso just a reasonable feminine reaction to the harsh realities of an increasingly more alienating and hard to exist in world. It's a survival strategy yk. And it doesn't mean she isn't thinking deep things just because she's hot and doesn't talk much about things of substance. But moreso that deeper thought is being reserved for when it is warranted. I think. I don't know really this isn't a well thought out thought I'm writing this at 4AM. Maybe I do just like being hot, and mean to men, and kinda vain and taking pictures of myself because I'm actually just an agp male fetishist. Idk",
            date: "3/31/2026"
        },
        {
            name: "I am my mother's daughter",
            thought: "Fuck... yeah I think I might just be my mother's daughter. She listened to Howard Stern and now I'm listening to Adam Friedland. I come from a line of black women who find jackass white dudes entertaining.",
            date: "3/14/2026"
        }
        
        
    ]
    
    const [selectedEntry, setSelectedEntry] = useState(Entries[0]);
    const [photoIndex, setPhotoIndex] = useState(0);
    
    const loadContent = (desc) => {
        descBox.current.innerHtml = desc;
    }
    
    
    const navigate = useNavigate();
    
    const handleRedirect = (dir) => {
        navigate(dir);
    };
    
    const handleEntryClick = (entry) => {
      setSelectedEntry(entry);
      setPhotoIndex(0);
    };
    
    const listItems = Entries.map((Entry, index) =>
                                  <div key={index}>
                                  <MenuListItem style={{height: 'auto'}} onClick={() => setSelectedEntry(Entry)} >
                                        <div style={{display: "flex", justifyContent: "space-around", width: "100%"}}>
                                            <span style={{width: "40%", wordBreak: "break-word", whiteSpace: "normal"}}>{Entry.name}</span>
                                            <span>{Entry.date}</span>
                                        </div>
                                  </MenuListItem>
                                  <Separator />
                                  </div>
                                  );
    
    return (
            <ThemeProvider theme={rose}>
            <Window resizable className='window' style={{ display: 'block',width: '80%', height: '75vh' }}>
            <WindowHeader className='window-title' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Random Thoughts</span>
            <Button style={{ marginRight: '2px', width: '20px', height: '20px', padding: 0 }} onClick={() => handleRedirect('/')}>
            <span style={{ fontWeight: 'bold', fontSize: '12px' }}>✕</span>
            </Button>
            </WindowHeader>
            
            <WindowContent style={{ height: 'calc(100% - 33px)', padding: 0 }}>
            <Frame variant='well' className='footer' style={{ height: '80%', margin: 0, display: 'flex' }}>
                <ScrollView style={{ height: '100%', width: '30%' }}>
                    <MenuList style={{display: 'flex', flexDirection: 'column'}}>
                        {listItems}
                    </MenuList>
                </ScrollView>
                <ScrollView style={{ height: '100%', width: '70%' }}>
            <div style={{ padding: '1rem' }}>
                    {selectedEntry.thought}
                    </div>
                </ScrollView>
            
              </Frame>
            
            
            </WindowContent>
            
          </Window>
          
          
    </ThemeProvider>
  );
}

export default AboutPage;
